import { Component, Output, EventEmitter, OnChanges, Input } from "@angular/core";
import { get, isEmpty } from 'lodash';
import { REMOVED } from "../../services/base.wizard.step";

@Component({
  selector: 'ntp-settings',
  templateUrl: './ntp.settings.template.html',
  styleUrls: ['./ntp.settings.style.scss']
})
export class NtpSettingsComponent implements OnChanges {
  // NTP settings are applicable to virtual agents only
  isVirtualAgentSelected = false;
  automaticNtpSelected = true;
  manualNtpSelected = false;
  loadAttempt = 0; // 0 - not yet, 1 - in progress, 2 - done (either OK or failure)
  address: any = null;

  @Input() parentOutput: any; // <
  @Input() step: any; //<
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Input() key: string; //@

  constructor() {

  }

  selectAutomaticNtp() {
    this.automaticNtpSelected = true;
    this.manualNtpSelected = false;
    this.fireUpdate();
  }

  selectManualNtp() {
    this.automaticNtpSelected = false;
    this.manualNtpSelected = true;
    this.fireUpdate();
  }

  updates() {
    this.fireUpdate();
  }

  mustBePresented() {
    return this.isVirtualAgentSelected;
  }

  _recalculateSelectionState() {
    // restore 'selection' if user clicked 'Back' to revisit the page
    const knownChoice = this.parentOutput[this.key];
    if (knownChoice && knownChoice !== REMOVED) {
      this.automaticNtpSelected = false;
      this.manualNtpSelected = true;
      this.address = knownChoice;
    }
  }

  /**
   * Please note this event is triggered only for one-way bindings (<)
   */
  ngOnChanges(changes) {
    setTimeout(() => {
      this.fireUpdate();

      if (this.loadAttempt === 0) {
        this.loadAttempt = 1;
        const agentType = get(this.parentOutput, 'agentType.id', "");
        this.isVirtualAgentSelected = agentType === 'virtual';
        this._recalculateSelectionState();
        this.fireUpdate();
        this.loadAttempt = 2;
      }
    }, 0);
  }

  _makeOutput() {
    if (!this.isVirtualAgentSelected) {
      // in case page was loaded with incorrect agent, make sure we reset data in output
      return null;
    }
    if (this.automaticNtpSelected) {
      return null;
    }

    return this.address;
  }

  fireUpdate() {
    setTimeout(() => {
      const dataOutput = this._makeOutput();
      let isValid = true;
      if (this.manualNtpSelected && isEmpty(this.address)) {
        isValid = false;
      }
      this.onUpdate.emit({ key: this.key,
value: dataOutput,
isValid });
    }, 0);
  }
}
